import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  CardActions,
  Button,
} from "@mui/material";
import Section from "./Section.jsx";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";
import { ReactComponent as LogoGoldSvg } from "../assets/logo-gold.svg";
import { ReactComponent as StarSvg } from "../assets/star-shine.svg";
import { ReactComponent as HourglassSvg } from "../assets/hourglass.svg";
import { ReactComponent as FeatherSvg } from "../assets/feather.svg";
import { ReactComponent as LeafSvg } from "../assets/leaf2.svg";
import { ReactComponent as LeafWindSvg } from "../assets/leaf-wind.svg";
import NutPng from "../assets/nut.png";
import PresentPng from "../assets/present.png";
import { ReactComponent as MenuBookSvg } from "../assets/menu-book.svg";
import PaletteIcon from "@mui/icons-material/Palette";
import WineBarIcon from "@mui/icons-material/WineBar";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DiamondIcon from "@mui/icons-material/Diamond";

import ResourceCarousel from "./ResourceCarousel.jsx";
import ButtonCarousel from "./ButtonCarousel.jsx";
import { useNavigate } from "react-router-dom";

const resourceMoments = [
  {
    title: "Ваш вільний ранок",
    Icon: "☕",
    isEmoji: true,
  },
  {
    title: "Час для творчості",
    Icon: "🎨",
    isEmoji: true,
  },
  {
    title: "Хвилька тиші",
    Icon: MenuBookSvg,
  },
];

const fredoomMoments = [
  {
    title: "Простір наповнюється світлом",
    Icon: StarSvg,
  },
  {
    title: "Кожна деталь стає досконалою",
    Icon: "💎",
    isEmoji: true,
  },
  {
    title: "Дім починає дихати",
    Icon: LeafSvg,
  },
];

const harmonyMoments = [
  {
    title: "Повітря наповнюється свіжістю",
    Icon: LeafWindSvg,
  },
  {
    title: "Краса в кожній деталі",
    Icon: "🌸",
    isEmoji: true,
  },
  {
    title: "Бездоганний блиск поверхонь",
    Icon: "✨",
    isEmoji: true,
  },
];

const tasteMoments = [
  {
    title: "Довершена форма тиші",
    Icon: NutPng,
    isImage: true,
  },
  {
    title: "Чистий смак життя",
    Icon: LeafSvg,
  },
  {
    title: "Таємний комплімент",
    Icon: PresentPng,
    isImage: true,
  },
];

export const createCompanyValues = (navigate) => [
  {
    title: "Вибір",
    description: (
      <Typography>
        Кожен простір має свій{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          характер
        </Typography>
        . Оберіть{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          формат
        </Typography>
        , який відповідає Вашому запиту:
      </Typography>
    ),
    additionalContent: (
      <ButtonCarousel
        showBorder={false}
        items={[
          <Button
            variant="outlined"
            onClick={() => navigate("/serviceDetails/after-repair")}
            sx={{
              borderColor: "#ffd700",
              color: "#5f2e20",
              borderRadius: "10px",
              textTransform: "none",
              width: "100%",
              whiteSpace: "nowrap",
              py: 2.5,
            }}
          >
            <Typography
              sx={{
                color: "#5f2e20",
                fontSize: "0.875rem",
                fontWeight: "bold",
              }}
            >
              Післяремонтне прибирання
            </Typography>
          </Button>,
          <Button
            variant="outlined"
            onClick={() => navigate("/serviceDetails/after-rent")}
            sx={{
              borderColor: "#ffd700",
              color: "#5f2e20",
              borderRadius: "10px",
              textTransform: "none",
              width: "100%",
              whiteSpace: "nowrap",
              py: 2,
            }}
          >
            <Typography
              sx={{
                color: "#5f2e20",
                fontSize: "0.875rem",
                fontWeight: "bold",
              }}
            >
              Післяорендне прибирання
            </Typography>
          </Button>,
          <Button
            variant="outlined"
            onClick={() => navigate("/serviceDetails/for-business")}
            sx={{
              borderColor: "#ffd700",
              color: "#5f2e20",
              borderRadius: "10px",
              textTransform: "none",
              width: "100%",
              py: 2,
            }}
          >
            <Typography
              sx={{
                color: "#5f2e20",
                fontSize: "0.875rem",
                fontWeight: "bold",
              }}
            >
              Для бізнесу
            </Typography>
          </Button>,
        ]}
      ></ButtonCarousel>
    ),
    Icon: StarSvg,
  },
  {
    title: "Ресурс",
    description: (
      <Typography>
        Час - це єдиний{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          актив
        </Typography>{" "}
        , який неможливо повернути. Визначте мить, з якої почнеться Ваша{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          свобода
        </Typography>
      </Typography>
    ),
    Icon: HourglassSvg,
    additionalContent: (
      <ResourceCarousel items={resourceMoments} showBorder={false} />
    ),
  },
  {
    title: "Свобода",
    description: (
      <Typography>
        Найкращі інвестиції - це{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          хвилини присвячені собі
        </Typography>
        . Поки ми дбаємо про кожну частиночку Вашого дому - Ви{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          наповнюєте життя новим сенсом
        </Typography>
        .
      </Typography>
    ),
    Icon: FeatherSvg,
    additionalContent: (
      <ResourceCarousel items={fredoomMoments} showBorder={false} />
    ),
  },
  {
    title: "Гармонія",
    description: (
      <Typography>
        Гармонія - це стан, коли простір і Ваші думки стають{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          єдиним цілим
        </Typography>
        . Повертайтесь туди, де кожна частиночка{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          дихає спокоєм
        </Typography>
        .
      </Typography>
    ),
    Icon: LogoSvg,
    additionalContent: (
      <ResourceCarousel items={harmonyMoments} showBorder={false} />
    ),
  },
  {
    title: "Післясмак",
    description: (
      <Typography>
        Справжня розкіш завжди залишає за собою{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          авторський відбиток
        </Typography>
        . Ми залишаємо для Вас дещо особливе -{" "}
        <Typography
          sx={{ color: "#ffd700", fontWeight: "bold" }}
          variant="span"
        >
          довершену форму Вашого відпочинку
        </Typography>
        .
      </Typography>
    ),
    Icon: FeatherSvg,
    additionalContent: (
      <ResourceCarousel items={tasteMoments} showBorder={false} />
    ),
  },
];
export default function Sequence() {
  const navigate = useNavigate();

  const companyValues = createCompanyValues(navigate);

  return (
    <Section
      id="advantages"
      title="Послідовність"
      headerStyles={{
        color: "#5f2e20",
        textDecoration: "underline",
        textDecorationColor: "#ffd700",
        ":after": { display: "none" },
        mt: 9,
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: "left",
          alignItems: "top",
          width: "100%",
        }}
        padding={2}
      >
        {companyValues.map((service) => {
          const { Icon } = service;
          return (
            <Grid key={service.title} sx={{ width: "100%" }}>
              <Typography
                variant="h6"
                sx={{ textAlign: "left", color: "#5f2e20" }}
              >
                {service.title}
              </Typography>
              <Card
                sx={{
                  position: "relative",
                  p: 1,
                  borderRadius: "15px",
                  ...(service.applyExtraStyling && {
                    background:
                      "linear-gradient(135deg, #fffaf0 0%, #fff8dc 40%, #fffaf0 100%)",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: "-50%",
                      left: "-50%",
                      width: "200%",
                      height: "200%",
                      background:
                        "linear-gradient(120deg, transparent 30%, rgba(255,215,0,0.25) 50%, transparent 70%)",
                      transform: "rotate(15deg)",
                      animation: "goldShimmer 4s linear infinite",
                      pointerEvents: "none",
                      zIndex: 0,
                    },
                    "@keyframes goldShimmer": {
                      "0%": {
                        transform: "translateX(-60%) rotate(15deg)",
                      },
                      "100%": {
                        transform: "translateX(60%) rotate(15deg)",
                      },
                    },
                  }),
                }}
              >
                <CardContent sx={{ textAlign: "left" }}>
                  <Box sx={{ position: "relative" }}>
                    {/* Icon floats and affects ONLY first line */}
                    <Box
                      sx={{
                        float: "left",
                        width: 28,
                        height: 28,
                        mx: 1.5,
                        mt: "4px",
                      }}
                    >
                      <Icon
                        style={{
                          width: "25px",
                          height: "25px",
                          display: "block",
                        }}
                      />
                    </Box>

                    {/* Text flows naturally around icon */}
                    <Box
                      component="span"
                      sx={{
                        display: "block",
                        color: "#5f2e20",
                        lineHeight: 1.6,
                        textAlign: "justify",
                      }}
                    >
                      {service.description}
                    </Box>

                    {/* Clear float so layout doesn't break below */}
                    <Box sx={{ clear: "both" }} />
                  </Box>
                </CardContent>
                {service.additionalContent && (
                  <CardActions
                    sx={{
                      px: 2,
                      pb: 2,
                      justifyContent: "center",
                    }}
                  >
                    {service.additionalContent}
                  </CardActions>
                )}

                <LogoGoldSvg
                  style={{
                    position: "absolute",
                    bottom: "6px",
                    right: "6px",
                    width: "20px",
                    height: "20px",
                    opacity: 0.8,
                    pointerEvents: "none",
                  }}
                />
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Section>
  );
}
